<template>
  <span v-if="type == 'text'">
    {{ appliedRiskValue }}
  </span>
  <div v-else-if="type == 'badge'">
    <button class="button rbutton" :class="[buttonClass]">{{ appliedRiskValue }}</button>
  </div>
  <div v-else class="d-flex align-items-center justify-content-between" style="margin-top: 2.37rem;">
    <div class="rval">
      {{ $t("risk.applied-risk-value.text") }}
      <i class="font-size-22" :class="[arrowClass]"></i>
    </div>
    <button class="button rbutton" :class="[buttonClass]">{{ appliedRiskValue }}</button>
  </div>
</template>

<script>
export default {
  props: [
    "risk",
    "type", //badge,text,undefined=full
  ],
  computed: {
    appliedRiskValue() {
      if (this.risk.appliedRiskValue == "LOWEST") {
        return this.$t("risk.applied-risk-value.lowest");
      } else if (this.risk.appliedRiskValue == "LOW") {
        return this.$t("risk.applied-risk-value.low");
      } else if (this.risk.appliedRiskValue == "MEDIUM") {
        return this.$t("risk.applied-risk-value.medium");
      } else if (this.risk.appliedRiskValue == "HIGH") {
        return this.$t("risk.applied-risk-value.high");
      }
      return this.$t("risk.applied-risk-value.highest");
    },
    buttonClass() {
      return this.risk.appliedRiskValue.toLowerCase();
    },
    arrowClass() {
      if (this.risk.appliedRiskValue == "LOWEST") {
        return "bx bx-chevrons-down lowest";
      } else if (this.risk.appliedRiskValue == "LOW") {
        return "bx bx-chevron-down low";
      } else if (this.risk.appliedRiskValue == "MEDIUM") {
        return "iconoir-git-commit medium";
      } else if (this.risk.appliedRiskValue == "HIGH") {
        return "bx bx-chevron-up high";
      }
      return "bx bx-chevrons-up highest";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../organization-risk-view.scss";
</style>

<style scoped>
.rbutton.lowest,
.rbutton.low {
  background-color: #e5f4e6;
}

.rbutton.medium {
  background-color: #e5e8f4;
}
.rbutton.high,
.rbutton.highest {
  background-color: #f4e5e5;
}

.lowest,
.low {
  color: #2ecd06;
}
.medium {
  color: rgb(70, 70, 253);
}
.high,
.highest {
  color: #ef3838;
}
</style>
